
import { supabase } from '@/lib/supabase';
import { v4 as uuidv4 } from 'uuid';

/**
 * This utility checks if the user has any assistant data and sets the migration flag
 * to avoid showing the migration UI unnecessarily. The old migration logic has been 
 * removed as the database structure now uses assistant_sessions and assistant_messages tables.
 */
export const migrateAssistantData = async (userId: string) => {
  try {
    // Check if the user has any sessions
    const { data: sessions, error: sessionsError } = await supabase
      .from('assistant_sessions')
      .select('id')
      .eq('user_id', userId)
      .limit(1);
      
    if (sessionsError) {
      console.error('Error checking for user sessions:', sessionsError);
      return false;
    }
    
    // If user already has sessions, migration is considered complete
    if (sessions && sessions.length > 0) {
      console.log('User already has assistant sessions, marking migration as complete');
      return true;
    }
    
    // Check if user has any messages
    const { data: messages, error: messagesError } = await supabase
      .from('assistant_messages')
      .select('id')
      .eq('user_id', userId)
      .limit(1);
    
    if (messagesError) {
      console.error('Error checking for user messages:', messagesError);
      return false;
    }
    
    // If user already has messages, migration is considered complete
    if (messages && messages.length > 0) {
      console.log('User already has assistant messages, marking migration as complete');
      return true;
    }
    
    // If we reached here, the user has no assistant data yet, which is fine
    // We'll mark the migration as complete anyway, since there's nothing to migrate
    console.log('No assistant data found for user, marking migration as complete');
    return true;
  } catch (error) {
    console.error('Migration check error:', error);
    return false;
  }
};
